import PasswordInput from "../../TextInput/PasswordInput/PasswordInput";
import Typography from "../../Typography/Typography";
import styles from "./ValidatedPws.module.scss";

const ValidatedPws = (props) => {
	const {
		onChange = () => {},
		className,
		placeholder,
		label,
		formatter,
		error = false,
		setError,
		errorMessage = "",
	} = props;

	const errorMjs = errorMessage || "Campo inválido";

	return (
		<div className={`${styles.validatedPwsContainer} ${className}`}>
			<PasswordInput
				onChange={onChange}
				className={className}
				placeholder={placeholder}
				label={label}
				formatter={formatter}
				error={error}
				setError={setError}
			></PasswordInput>

			{error ? (
				<Typography
					className={styles.validatedPwsErrorMjs}
					color="red"
					variant="p2"
				>
					{errorMjs}
				</Typography>
			) : (
				<div className={styles.validatedPwsError}>.</div>
			)}
		</div>
	);
};

export default ValidatedPws;
